module.exports = __webpack_public_path__ + "img/camera-corner-bottom-left.c5930099.png";